var _defs, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".happy-1{fill:#039fe3;}.happy-2,.happy-3{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.happy-2{stroke:#1d1d1b;}.happy-3{stroke:#000;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "icon_rating_bg",
    className: "happy-1",
    cx: 50,
    cy: 50,
    r: 48.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "happy-2",
    d: "M38.94,29.7S35.39,44.13,27.19,43.5s-8.46-11.9-8-16.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "happy-2",
    d: "M73.91,32.45S71.33,47.08,63.1,47,53.87,35.69,54,31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "happy-3",
    d: "M29.87,51.32s11.47,18.84,29.59,3.35"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.7c2d6bd5dd33aa019905646335fe3c0d.svg";
export { ForwardRef as ReactComponent };